<template>
    <v-container id="price" fluid class="py-12">
        <v-row justify="center" data-track-content data-content-name="Kartu Pendaftaran">
            <price-item
                v-for="period in tryoutPeriods"
                :key="period.id"
                :price="period"
                @register="toTryoutRegistration(period)"
            >
            </price-item>

            <!-- <price-item
                @register="toTutoringRegistration"
                :price="tutoringPrice"
                tutoring
            ></price-item> -->
        </v-row>
    </v-container>
</template>

<script>
import scrollTo from '@/tools/scrollTo'
import PriceItem from './components/PriceItem'

export default {
    components: {
        PriceItem,
    },

    data() {
        return {
            tryoutPeriods: [],
            tutoringPrice: {
                title: 'Bimbingan Belajar',
                price: 135000,
                description: 'Bimbingan S-1, Koas dan UKMMPD\nBimbingan S1-Koas termurah, dapat menguhubungi admin!\nBimbingan UKMPPD berupa online dan offline'
            }
        }
    },

    methods: {
        scrollTo,

        toTryoutRegistration(period) {
            this.scrollTo('#jumbotron')
            this.$store.set('home/authTab', 1)
            this.$store.set('home/period', period)

            // According to SignupForm.vue
            this.$store.set('home/signupStep', 3)
            this.$store.set('home/groupName', null)
            this.$store.set('home/signupTryoutBackTo', 1)

            this.$tracking.event.program.click(period.title)
        },

        toTutoringRegistration() {
            this.scrollTo('#jumbotron')
            this.$store.set('home/authTab', 1)

            this.$store.set('home/signupStep', 2)
        }
    },

    created() {
        this.$api.get('tryoutPeriod')
            .then(response => {
                this.tryoutPeriods = response.data.tryoutPeriods
                // this.$tracking.impressionWithinNode(this.$el)

                // const observer = new IntersectionObserver(entries => {
                //     const container = entries[0]
                //     console.log(container)
                // }, {
                //     threshold: 0.5
                // })

                // observer.observe(this.$el)
            })
    }
}
</script>
